import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import cx from 'classnames';
import { getDebugInfo } from '../../../common/utils';
import '../styles/_player_context_menu.scss';


















class PlayerContextMenu extends Component {


  constructor() {
    super();

    this.state = { coordinates: null };
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  getMenuOverlay() {
    const { coordinates } = this.state;

    if (!coordinates) {return null;}

    const { x, y } = coordinates;

    return (
      <div className="context-menu" ref={this.setMenuRef} style={{ left: x, top: y }}>
        <CopyToClipboard text={window.location.href} onCopy={this.hideMenu}>
          <p>Copy video URL</p>
        </CopyToClipboard>

        <CopyToClipboard text={getDebugInfo()} onCopy={this.hideMenu}>
          <p>Copy debug info</p>
        </CopyToClipboard>
      </div>);

  }

  hideMenu = () => {
    document.removeEventListener('mousedown', this.handleClick);

    this.setState({ coordinates: null });
  };

  showMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();
    document.addEventListener('mousedown', this.handleClick);

    this.setState({ coordinates: { x: event.clientX, y: event.clientY } });
  };

  handleClick = (event) => {
    const menu = this._menuRef;

    if (!event || !menu || menu.contains(event.target)) {
      return void 0;
    }

    this.hideMenu();
  };

  setMenuRef = (menuRef) => {
    if (!menuRef) {return;}

    this._menuRef = menuRef;
  };

  render() {
    const { children, isDisabled } = this.props;
    const overlay = this.getMenuOverlay();

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        className={cx('overlay-container', { 'overlay-container__disabled': isDisabled })}
        role="button"
        tabIndex={0}
        onClick={this.handleClick}
        onContextMenu={this.showMenu}>

        {overlay}
        {children}
      </div>);

  }
}
export default PlayerContextMenu;